import React from 'react';
import classNames from 'styles/utils/classNames';
import { formatMarketCap, formatShares } from '../../utils/formatUtils';

interface IPOCardProps {
  item: any;
  isBookmarked: boolean;
  onBookmark: (symbol: string) => void;
}

export const IPOCard: React.FC<IPOCardProps> = ({ item }) => {

  const status = item.actions;
  const statusColors = {
    'Priced': 'text-green-500 bg-green-500/10',
    'Filed': 'text-blue-500 bg-blue-500/10',
    'Withdrawn': 'text-red-500 bg-red-500/10',
    'Expected': 'text-yellow-500 bg-yellow-500/10',
    'Postponed': 'text-orange-500 bg-orange-500/10',
    'Cancelled': 'text-red-600 bg-red-600/10',
  };
  const statusColor = statusColors[status as keyof typeof statusColors] || 'text-gray-400 bg-gray-400/10';

  return (
    <div className="rounded-lg border border-palette-border bg-palette-black-2 p-4">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-start gap-2">
          <div>
            <div className="text-white text-xs font-semibold">
              {item.company}
            </div>
            <div className="text-gray-400 text-xs">
              {item.ticker && (
                <div className="text-xs text-gray-400">{item.ticker}</div>
              )}
            </div>
          </div>
        </div>
        <div className="text-right">
          <div className="text-gray-400 text-xs">
            <div className={classNames('text-xs px-2 py-1 rounded font-medium', statusColor)}>
              {status}
            </div>
          </div>
          <div className="text-white text-xs py-1">{item.date}</div>
        </div>
      </div>
      <div className="space-y-2 mt-3">
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div>
            <span className="block text-gray-400 text-xs">Exchange</span>
            <span>{item.exchange}</span>
          </div>
          <div className="text-right">
            <span className="block text-gray-400 text-xs">Shares</span>
            <span>{item.shares ? formatShares(item.shares) : '--'}</span>
          </div>
        </div>
      </div>
      <div className="space-y-2 mt-3">
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div>
            <span className="block text-gray-400 text-xs">Price Range</span>
            <span>{item.priceRange ? `${item.priceRange}` : '--'}</span>
          </div>
          <div className="text-right">
            <span className="block text-gray-400 text-xs">Market Cap</span>
            <span>{item.marketCap ? formatMarketCap(item.marketCap) : '--'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};